import React, { useState } from "react";
import styles from "./styles.module.css";
import clsx from "clsx";
import CardComponent from "../CardComponent";
import { useTranslation } from "react-i18next";
import ProgressBar from "../ProgressBar";
import { ReactComponent as DoorIcon } from "../../assets/door-icon.svg";
import { ReactComponent as MedalIcon } from "../../assets/medal-icon.svg";
import { RUPEE_ICON } from "../../appConstants/AppConstant";
import { Widget, WidgetItem } from "../../interfaces/TournamentsConfig";

interface PrizePoolCardProps {
  tournament: WidgetItem;
}

const PrizePoolCard: React.FC<PrizePoolCardProps> = ({tournament }) => {
  const { t } = useTranslation();

  const { numRegistrations=0, maxParticipants=0, generalInfo, ltid } = tournament || {}
  const [localNumRegistrations, setLocalNumRegistrations] = useState(numRegistrations)


  

  const prizeDetailing = [
    {
      icon: <DoorIcon />,
      label: t("feePerEntry"),
      value: generalInfo?.entryFeeText,
    },
    {
      icon: <MedalIcon />,
      label: t("firstPrize"),
      value: generalInfo?.firstPrizeText,
    }
  ];

  return (
    <CardComponent className={clsx(styles.prizePoolCard)} borderType="Md">
      <div className={clsx(styles.prizePoolBox)}>
        <label className={clsx(styles.label, "fontWeightMedium fontSizeXs fontColor666 textUppercase")}>
          {t("prizePool")}
        </label>
        <div className={clsx(styles.prizePoolValue, "fontSizeMd fontWeightBold fontColorBlack")}>{generalInfo?.prizePoolText}</div>
        <ProgressBar 
          value={localNumRegistrations} 
          max={maxParticipants} 
          entriesStatusClassName={clsx(styles.entriesStatus, "fontWeightBoldImp fontColorBlackImp textAlignLeft")} 
        />
        <div className={clsx(styles.prizeDetailingBox)}>
          {prizeDetailing.map(({ icon, label, value }, index) => (
            <div className={clsx(styles.prizeDetailContent)} key={index}>
              <div className={styles.iconBox}>{icon}</div>
              <div className={styles.contentBox}>
                <label className={clsx(styles.label, "fontWeightMedium fontSizeXs fontColor333 textUppercase")}>
                  {label}
                </label>
                <div className={clsx(styles.value, "fontWeightBold fontSize14 fontColorBlack")}>{value}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </CardComponent>
  );
};

export default PrizePoolCard;
